import {Injectable} from '@angular/core';
import {EventService} from '@spartacus/core';
import {ProductDetailsPageEvent} from '@spartacus/storefront';
import {Router} from '@angular/router';
import {AbstractLocalStorageService} from '../common/abstract-local-storage.service';
import {LocalStorageService} from '@dcp/configurator';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

export const PRODUCT_DETAILS_PAGES_LATEST_URL: string = 'productDetailsPageLatestUrl';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class ProductDetailsPageHistoryService extends AbstractLocalStorageService {

  protected currentValue: string;

  constructor(
    protected localStorageService: LocalStorageService,
    private eventService: EventService,
    private router: Router
  ) {
    super(localStorageService);
    this.setLocalStorageKey(PRODUCT_DETAILS_PAGES_LATEST_URL);
    this.eventService.get(ProductDetailsPageEvent).pipe(untilDestroyed(this)).subscribe(() => {
      this.currentValue = this.router.url;
      this.setStorageValue(this.currentValue);
    });
  }
}
